import { render, staticRenderFns } from "./ND-SL-Disclosure.vue?vue&type=template&id=299187e3&scoped=true&"
import script from "./ND-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./ND-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./ND-SL-Disclosure.vue?vue&type=style&index=0&id=299187e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299187e3",
  null
  
)

export default component.exports